var map = {
  "./ru.json": [
    "525959",
    "211036"
  ],
  "./uk.json": [
    "790007",
    "622376"
  ],
  "./bg.json": [
    "613087",
    "87043"
  ],
  "./el.json": [
    "90025",
    "9718"
  ],
  "./en-pt.json": [
    "761695",
    "518119"
  ],
  "./ja.json": [
    "743446",
    "441694"
  ],
  "./sv.json": [
    "736045",
    "539296"
  ],
  "./sr.json": [
    "465126",
    "145893"
  ],
  "./zh-hans.json": [
    "408239",
    "227530"
  ],
  "./fr.json": [
    "796292",
    "803268"
  ],
  "./kk.json": [
    "634108",
    "425186"
  ],
  "./nb.json": [
    "863664",
    "917744"
  ],
  "./uz.json": [
    "471828",
    "20275"
  ],
  "./ky.json": [
    "596215",
    "648829"
  ],
  "./pl.json": [
    "406783",
    "138036"
  ],
  "./ro.json": [
    "115149",
    "541640"
  ],
  "./ka.json": [
    "191869",
    "914563"
  ],
  "./hu.json": [
    "899191",
    "478593"
  ],
  "./or.json": [
    "966034",
    "130816"
  ],
  "./hy.json": [
    "170060",
    "198424"
  ],
  "./de.json": [
    "813530",
    "868518"
  ],
  "./vi.json": [
    "274878",
    "782331"
  ],
  "./tr.json": [
    "475923",
    "189699"
  ],
  "./id.json": [
    "525270",
    "829645"
  ],
  "./lt.json": [
    "296614",
    "712709"
  ],
  "./lv.json": [
    "119743",
    "968628"
  ],
  "./es.json": [
    "691120",
    "272783"
  ],
  "./bn.json": [
    "282349",
    "372748"
  ],
  "./cs.json": [
    "402478",
    "371367"
  ],
  "./boxes.json": [
    "901042",
    "629687"
  ],
  "./sk.json": [
    "525972",
    "503354"
  ],
  "./nl.json": [
    "139114",
    "494519"
  ],
  "./az.json": [
    "411570",
    "52281"
  ],
  "./accents.json": [
    "518485",
    "928814"
  ],
  "./pa.json": [
    "778581",
    "40907"
  ],
  "./pt.json": [
    "284594",
    "350701"
  ],
  "./extra.json": [
    "416596",
    "109489"
  ],
  "./it.json": [
    "122931",
    "134125"
  ],
  "./hi.json": [
    "15537",
    "178561"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 558901;
module.exports = webpackAsyncContext;
